import 'jquery.cookie';

import CashBackDgView from '@/js/desktop/components/cashbackDg/cashbackDg';
import noMirService from '@/js/common/services/noMirService';

const initBanners = () => {
    noMirService('cashbackBanner-closed');
    const appConfig = window?.appConfig;
    const cashbackAvailable = appConfig?.cashbackAvailable;
    const disableCashbackPopup = appConfig?.disableCashbackPopup;
    if (!disableCashbackPopup && cashbackAvailable && !$.cookie('cashbackBanner-closed')
        && window.appConfig?.cashbackSettings?.popupHtml
        && window.appConfig?.cashbackSettings?.landingUrl
    ) {
        new CashBackDgView({
            el: '.js-cashback-dg',
            cookieName: 'cashbackBanner-closed',
        });
    }
};

if (!window.hideBanner) {
    initBanners();
}
